import type { ReactNode } from 'react';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { hasAtLeast } from '@/lib/roles';
import type { ClientRole } from '@/types/user';

// Presentation only. The API enforces the same floor with RequireClientRole, so hiding a
// control here never stands in for authorization.
export function RequireRole({ min, children }: { min: ClientRole; children: ReactNode }) {
  const { data: user } = useCurrentUser();

  return hasAtLeast(user?.clientRole, min) ? <>{children}</> : null;
}
